import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { DevMode } from './components/DevMode';
import { TrustPointsApp } from './components/TrustPointsApp';
import { ArchitectureDiagram } from './components/ArchitectureDiagram';
import { ProjectStructure } from './components/ProjectStructure';

function App() {
  return (
    <DevMode>
      <Routes>
        <Route path="/" element={<TrustPointsApp />} />
        <Route path="/architecture" element={<ArchitectureDiagram />} />
        <Route path="/structure" element={<ProjectStructure />} />
      </Routes>
    </DevMode>
  );
}

export default App;
